import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0fde7e85"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 售后详情 ");
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  key: 0,
  class: "img",
  src: "https://p6.moimg.net/md/after_sale/after_sale_logistics.png"
};
const _hoisted_6 = {
  key: 1,
  class: "img",
  src: "https://p6.moimg.net/md/after_sale/after_sale_back.png"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "icon"
})], -1));
const _hoisted_8 = {
  class: "after-sale-cont-bottom"
};
const _hoisted_9 = {
  class: "order-info"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "order-info-tit"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/md/after_sale/after_sale_orders.png"
}), /*#__PURE__*/_createElementVNode("strong", null, "订单信息")], -1));
const _hoisted_11 = {
  class: "order-info-item"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "订单编号", -1));
const _hoisted_13 = {
  class: "info"
};
const _hoisted_14 = ["copyData"];
const _hoisted_15 = {
  class: "order-info-item"
};
const _hoisted_16 = {
  class: "info info-reason"
};
const _hoisted_17 = {
  class: "order-info-item"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "售后编号", -1));
const _hoisted_19 = {
  class: "info"
};
const _hoisted_20 = ["copyData"];
const _hoisted_21 = {
  key: 1,
  class: "order-info-customer-row"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "modian-icon icon-customer"
}, null, -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "联系平台客服", -1));
const _hoisted_24 = [_hoisted_22, _hoisted_23];
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "modian-icon icon-customer"
}, null, -1));
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "联系平台客服", -1));
const _hoisted_27 = [_hoisted_25, _hoisted_26];
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "modian-icon icon-customer"
}, null, -1));
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "联系商家客服", -1));
const _hoisted_30 = [_hoisted_28, _hoisted_29];
const _hoisted_31 = {
  key: 2,
  class: "apply-wrap"
};
const _hoisted_32 = {
  class: "apply-wrap-tit"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tit-icon",
  src: "https://p6.moimg.net/md/after_sale/after_sale_imgs.png"
}, null, -1));
const _hoisted_34 = {
  class: "apply-wrap-cont"
};
const _hoisted_35 = {
  key: 0,
  class: "apply-wrap-imgs"
};
const _hoisted_36 = ["poster", "src", "onClick"];
const _hoisted_37 = ["onClick"];
const _hoisted_38 = ["src", "onClick"];
const _hoisted_39 = {
  key: 2,
  class: "error-box"
};
const _hoisted_40 = {
  class: "overlay-video-box"
};
const _hoisted_41 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_CompStep = _resolveComponent("CompStep");
  const _component_CompDescribe = _resolveComponent("CompDescribe");
  const _component_CompUserAddress = _resolveComponent("CompUserAddress");
  const _component_CompProInfo = _resolveComponent("CompProInfo");
  const _component_Error = _resolveComponent("Error");
  const _component_van_overlay = _resolveComponent("van-overlay");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['after-sale-box', [{
      'boxIOS': $data.env.isModianIos()
    }, {
      'boxAndroid': $data.env.isModianAndroid()
    }]])
  }, [!$data.env.isWxApp() ? (_openBlock(), _createElementBlock("header", _hoisted_1, [_createElementVNode("strong", null, [_hoisted_2, _createVNode(_component_icon, {
    class: "back-icon",
    name: "https://p6.moimg.net/md/jsheader/back.png",
    onClick: _cache[0] || (_cache[0] = _withModifiers($event => $options.back(), ["stop"]))
  })])])) : _createCommentVNode("", true), $data.business_code ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(['after-sale-cont', {
      'after-sale-cont-wxapp': $data.env.isWxApp()
    }])
  }, [$data.refund_time_line && $data.refund_time_line.length ? (_openBlock(), _createBlock(_component_CompStep, {
    key: 0,
    refund_time_line: $data.refund_time_line
  }, null, 8, ["refund_time_line"])) : _createCommentVNode("", true), _createVNode(_component_CompDescribe, {
    status_describe: $data.aftersale_info.status_describe,
    cp_address: $data.logistics_info.cp_address,
    btn_list: $data.btn_list,
    pro_info: $data.pro_info,
    aftersale_id: $data.aftersale_info.aftersale_id,
    order_id: $data.order_info.order_id,
    aftersale_type: $data.aftersale_info.aftersale_type,
    onReload: $options.reload
  }, null, 8, ["status_describe", "cp_address", "btn_list", "pro_info", "aftersale_id", "order_id", "aftersale_type", "onReload"]), $data.logistics_info.delivers && $data.logistics_info.delivers.length ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.logistics_info.delivers, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "delivers-box",
      onClick: $event => $options.goLogisticsInfo(item)
    }, [item.type == 1 ? (_openBlock(), _createElementBlock("img", _hoisted_5)) : item.type == 2 ? (_openBlock(), _createElementBlock("img", _hoisted_6)) : _createCommentVNode("", true), _createElementVNode("strong", null, _toDisplayString(item.title_1), 1), _hoisted_7], 8, _hoisted_4);
  }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [$data.logistics_info.user_address ? (_openBlock(), _createBlock(_component_CompUserAddress, {
    key: 0,
    user_address: $data.logistics_info.user_address
  }, null, 8, ["user_address"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createVNode(_component_CompProInfo, {
    pro_info: $data.pro_info,
    reward_info: $data.reward_info,
    reward_num: $data.order_info.reward_num
  }, null, 8, ["pro_info", "reward_info", "reward_num"]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("span", _hoisted_13, _toDisplayString($data.order_info.order_id), 1), _createElementVNode("span", {
    class: "copy-icon",
    copyData: $data.order_info.order_id,
    onClick: _cache[1] || (_cache[1] = _withModifiers($event => $options.CopyContent($event, $data.order_info.order_id), ["stop"]))
  }, "复制", 8, _hoisted_14)]), _createElementVNode("div", _hoisted_15, [_createElementVNode("label", null, _toDisplayString($data.aftersale_info.aftersale_type == 2 ? '申诉原因' : '售后原因'), 1), _createElementVNode("span", _hoisted_16, _toDisplayString($data.aftersale_info.apply_reson_type_name), 1)]), _createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("span", _hoisted_19, _toDisplayString($data.aftersale_info.aftersale_id), 1), _createElementVNode("span", {
    class: "copy-icon",
    copyData: $data.aftersale_info.aftersale_id,
    onClick: _cache[2] || (_cache[2] = _withModifiers($event => $options.CopyContent($event, $data.aftersale_info.aftersale_id), ["stop"]))
  }, "复制", 8, _hoisted_20)])]), $data.env.isModianIos() || $data.env.isModianAndroid() ? (_openBlock(), _createElementBlock("div", _hoisted_21, [$data.business_code == 4 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "order-info-customer",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.goPlatformChat && $options.goPlatformChat(...args))
  }, _hoisted_24)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createElementVNode("div", {
    class: "order-info-customer",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.goPlatformChat && $options.goPlatformChat(...args))
  }, _hoisted_27), _createElementVNode("div", {
    class: "order-info-customer",
    onClick: _cache[5] || (_cache[5] = (...args) => $options.goSellerChat && $options.goSellerChat(...args))
  }, _hoisted_30)], 64))])) : _createCommentVNode("", true), $data.aftersale_info.apply_reson_content || $data.aftersale_info.apply_attachment && $data.aftersale_info.apply_attachment.length ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_hoisted_33, _createElementVNode("strong", null, _toDisplayString($data.aftersale_info.aftersale_type == 2 ? '补充凭证' : '补充凭证和描述'), 1)]), _createElementVNode("div", _hoisted_34, _toDisplayString($data.aftersale_info.apply_reson_content), 1), $data.aftersale_info.apply_attachment && $data.aftersale_info.apply_attachment.length ? (_openBlock(), _createElementBlock("div", _hoisted_35, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.aftersale_info.apply_attachment, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(['imgs-item', {
        'imgs-item-right': (index + 1) % 3 == 0
      }]),
      key: index
    }, [item.file_type == 'video' ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createElementVNode("video", {
      poster: item.video_cover,
      src: item.url,
      onClick: $event => $options.playVideo(item)
    }, null, 8, _hoisted_36), _createElementVNode("i", {
      onClick: $event => $options.playVideo(item),
      class: "play-icon"
    }, null, 8, _hoisted_37)], 64)) : (_openBlock(), _createElementBlock("img", {
      key: 1,
      src: _ctx.$imgUrlFilter(item.url, Math.round(216 * $data.domPixelRatio())),
      onClick: $event => $options.showBigImg(index)
    }, null, 8, _hoisted_38))], 2);
  }), 128))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])], 2)) : $data.loaded ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_createVNode(_component_Error, {
    message: "未查询到售后信息"
  })])) : _createCommentVNode("", true), _createVNode(_component_van_overlay, {
    show: $data.showVideo,
    onClick: _cache[7] || (_cache[7] = $event => $data.showVideo = false)
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_40, [_createElementVNode("video", {
      onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
      src: $data.videoUrl,
      controls: "",
      muted: "",
      autoplay: "",
      playsinline: "true",
      "webkit-playsinline": "true"
    }, null, 8, _hoisted_41)])]),
    _: 1
  }, 8, ["show"])], 2);
}